import React from 'react';
import { Translate } from 'core/translate';
import { withNotifications } from '../../common/notifications/NotificationsContext';
import Currency from '../../common/intl/Currency';
import { Dagger } from '../../common/notifications/NotificationsTrigger';
import { combineClassNames } from 'core/css';

const DisclaimerContainer = props => {
  const {
    analyticsKey,
    analyticsKey2,
    disclaimer,
    notifications,
    children
  } = props;
  const { disabled, show } = notifications;

  if (disabled) {
    return <div>{children}</div>;
  }

  return (
    <div
      className="stat-disclaim"
      data-dtm={analyticsKey}
      data-dtm2={analyticsKey2}
      onClick={event => {
        event.preventDefault();
        show(disclaimer, event);
      }}>
      {children}
      <div className="show-for-sr">{disclaimer}</div>
    </div>
  );
};

const PriceWithDisclaimer = props => {
  const { value, message, notifications } = props;
  const { disabled } = notifications;

  const label = (
    <span>
      <Translate value="component.pricing.from.no.asterisk" />{' '}
    </span>
  );

  const symbol = !disabled && <Dagger />;

  const content = message ? (
    <span className={combineClassNames([disabled ? '' : 'disclaimer'])}>
      {message} {symbol}
    </span>
  ) : (
    <React.Fragment>
      {label}
      <span
        className={combineClassNames([
          'price',
          'option__price',
          disabled ? '' : 'disclaimer'
        ])}>
        <Currency value={value} /> {symbol}
      </span>
    </React.Fragment>
  );

  return <DisclaimerContainer {...props}>{content}</DisclaimerContainer>;
};

export default withNotifications(PriceWithDisclaimer);
